import { c as _c } from "react/compiler-runtime";
import { Factors } from '@commutifi-fe/constants';
import { useComponentIntl } from '../../locales';
export function MetricLabel(t0) {
  const $ = _c(3);
  const {
    metricType
  } = t0;
  const intl = useComponentIntl("Metrics");
  let t1;
  if ($[0] !== intl || $[1] !== metricType) {
    t1 = intl.formatMessage({
      id: `label.${metricType}`
    });
    $[0] = intl;
    $[1] = metricType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export default MetricLabel;